import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
  } from "@angular/core";
  import { GlobalComponent } from "src/app/global/global.component";
  import {
    clientDetails,
    SaveVisitScheduleBO,
    ScheduleEventEmitterBo,
  } from "../schedule.modal";
  import { ToastrService } from "ngx-toastr";
  import { ScheduleEditService } from "./schedule-edit.service";
  import { EditDetailsAuthorization } from "../../client-parent/client-parent.model";
  import { DatePipe } from "@angular/common";
  import { GridComponent } from "@syncfusion/ej2-angular-grids";
  import { IMyDpOptions } from "mydatepicker";
  import { DateService } from "src/app/date.service";
  import { CommonHttpService } from "src/app/common.service";
  import { ClientHttpService } from "../../client-parent/client-parent.service";
  import { ColumnChangeBO, columnWidth } from "../../employee/employee.model";
  import { takeUntil } from "rxjs/operators";
  import { Subject } from "rxjs";
  @Component({
    selector: "app-schedule-edit",
    templateUrl: "./schedule-edit.component.html",
    styleUrls: ["./schedule-edit.component.scss"],
  })
  export class ScheduleEditComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>();
    @ViewChild("gridAuthDetails") public gridAuthDetails: GridComponent;
    @Input() DataFromAuthorizationList: EditDetailsAuthorization =
      new EditDetailsAuthorization();
    @Output() EventToEditAuth = new EventEmitter<EditDetailsAuthorization>();
    @Input() EditScheduleInputProperty: ScheduleEventEmitterBo =
      new ScheduleEventEmitterBo();
    @Output() EditOutputSchedule = new EventEmitter<ScheduleEventEmitterBo>();
    EditAuthorization: boolean = false;
    ColumnsScheduleEdit: columnWidth[];
    initialPage: object;
    arraycol: any = [];
    clientDetails: clientDetails = new clientDetails();
    type: string = "";
    id: number = 0;
    showDays: boolean = false;
    columnchange: ColumnChangeBO = new ColumnChangeBO();
    AppointmentColumn: boolean = false;
    EmployeeDropdown: any = [];
    AppointmentArrayList: SaveVisitScheduleBO[] = [];
    public pageSizes: number[] = [10, 15, 20, 50];
    AuthorizationInputDetails: EditDetailsAuthorization =
      new EditDetailsAuthorization();
    showErr: string;
    EditEmployeeId: any;
    EditClientId: any;
    AuthorizationDetails: any = [];
    FrequencyDays: any = [];
    formatOptions: object;
    public PastandFutureOption: IMyDpOptions = {
      dateFormat: "mm/dd/yyyy",
      disableUntil: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate() - 1,
      },
      showClearDateBtn: false,
      editableDateField: true,
    };
    serviceList:any[] = [];
    IsButtonDisable: boolean = false;

    constructor(
      public ClientService: ClientHttpService,
      public commonservice: CommonHttpService,
      public dateservice: DateService,
      public datePipe: DatePipe,
      public global: GlobalComponent,
      public toasterService: ToastrService,
      public EditService: ScheduleEditService
    ) {}
    ngOnInit(): void {
      this.refreshToGetDropDownValues("CUSTOMFREQUENCY");
      this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
      this.initialPage = {
        currentPage: 1,
        totalRecordsCount: 0,
        pageCount: 10,
        pageSize: this.pageSizes[0],
        pageSizes: this.pageSizes,
      };
      let appointment = new SaveVisitScheduleBO();
      appointment.FrequencyDays = this.getFrequencyDays();
  
      this.AppointmentArrayList.push(appointment);
    }
    //.............................................AddClientAuthorization....................................................
    AddClientAuthorization(Status, data) {
      this.AuthorizationInputDetails.isView = false;
      if (Status == "new") {
        this.AuthorizationInputDetails.isEdit = true;
        this.AuthorizationInputDetails.type = "new";
        this.AuthorizationInputDetails.ClientId = this.EditClientId;
        this.AuthorizationInputDetails.AuthorizationId = '00000000-0000-0000-0000-000000000000';
        this.EventToEditAuth.emit(this.AuthorizationInputDetails);
      }
      if (Status == "edit") {
        this.AuthorizationInputDetails.AuthorizationId = data.id;
        this.AuthorizationInputDetails.type = "edit";
        this.AuthorizationInputDetails.isEdit = true;
        this.AuthorizationInputDetails.ClientId = this.EditClientId;
        this.AuthorizationInputDetails.AuthorizationData = data;
        this.EventToEditAuth.emit(this.AuthorizationInputDetails);
      }
      this.EditAuthorization = true;
    }
    // ................................................AddAppointment...................................................
    AddAppointment() {
      if (this.AppointmentArrayList.length < 10) {
        if (this.AppointmentArrayList.length > 0) {
          this.AppointmentColumn = true;
        }
        let appointment = new SaveVisitScheduleBO();
        appointment.FrequencyDays = this.getFrequencyDays();
        this.AppointmentArrayList.push(appointment);
      }
    }
    // ................................................removeAppointment...................................................
    removeAppointment(Appointment) {
      if (this.AppointmentArrayList.length > 1) {
        this.AppointmentArrayList.splice(Appointment, 1);
      }
    }
    // ................................................getAuthDetails...................................................
    getAuthDetails() {
      if (
        this.EditClientId != null &&
        this.EditClientId != undefined &&
        this.EditClientId != ""
      ) {
        let params = new URLSearchParams();
        params.append("clientid", this.EditClientId.toString());
        this.EditService.getAuthorization(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((ADetails: any) => {
            ADetails = JSON.parse(ADetails);
            this.AuthorizationDetails = ADetails;
            if (
              ADetails != null &&
              ADetails != undefined &&
              ADetails.length > 10
            ) {
              this.gridAuthDetails.height = "500";
            } else {
              this.gridAuthDetails.height = "auto";
            }
          });
      } else {
        this.AuthorizationDetails = [];
      }
      this.AppointmentArrayList = [];
      let appointment = new SaveVisitScheduleBO();
      appointment.FrequencyDays = this.getFrequencyDays();
      this.AppointmentArrayList.push(appointment);
    }
    // ................................................checkScheduleValidation...................................................
    checkScheduleValidation() {
      this.IsButtonDisable = true;
      this.showErr = "";
      this.AppointmentArrayList.forEach((multipleAppointments) => {
        if (this.showErr == "") {
          if (
            multipleAppointments.employeeId == '00000000-0000-0000-0000-000000000000' ||
            multipleAppointments.employeeId == null ||
            multipleAppointments.employeeId == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Employee";
            this.toasterService.error("Please select Employee");
            return;
          }
          if (
            (multipleAppointments.serviceGroupId == '00000000-0000-0000-0000-000000000000' &&
              multipleAppointments.serviceGroupId == null) ||
            multipleAppointments.serviceGroupId == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Service Group";
            this.toasterService.error("Please select Service Group");
            return;
          }
          if (
            (multipleAppointments.serviceId == '00000000-0000-0000-0000-000000000000' &&
              multipleAppointments.serviceId == null) ||
            multipleAppointments.serviceId == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Service";
            this.toasterService.error("Please select Service");
            return;
          }
          if (
            multipleAppointments.startDate == null ||
            multipleAppointments.startDate == "" ||
            multipleAppointments.startDate == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Start date";
            this.toasterService.error("Please select Start date");
            return;
          }
          if (
            multipleAppointments.endDate == null ||
            multipleAppointments.endDate == "" ||
            multipleAppointments.endDate == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select End date";
            this.toasterService.error("Please select End date");
            return;
          }
          if (
            multipleAppointments.startTime == null ||
            multipleAppointments.startTime == "" ||
            multipleAppointments.startTime == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Start time";
            this.toasterService.error("Please select Start time");
            return;
          }
          if (
            multipleAppointments.endTime == null ||
            multipleAppointments.endTime == "" ||
            multipleAppointments.endTime == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select End time";
            this.toasterService.error("Please select End time");
            return;
          }
          if (
            multipleAppointments.customFrequencyLid == '00000000-0000-0000-0000-000000000000' ||
            multipleAppointments.customFrequencyLid == null ||
            multipleAppointments.customFrequencyLid == undefined
          ) {
            this.IsButtonDisable = false;
            this.showErr = "Please select Custom Frequency";
            this.toasterService.error("Please select Custom Frequency");
            return;
          }
          if (
            multipleAppointments.startDate != null &&
            multipleAppointments.startDate != "" &&
            multipleAppointments.startDate != undefined &&
            multipleAppointments.endDate != null &&
            multipleAppointments.endDate != "" &&
            multipleAppointments.endDate != undefined
          ) {
            if (
              new Date(multipleAppointments.startDate).getTime() >
              new Date(multipleAppointments.endDate).getTime()
            ) {
              this.IsButtonDisable = false;
              this.showErr = "End date should be greater than Start date";
              this.toasterService.error(
                "End date should greater than start date"
              );
              return;
            }
          }
          var currentdate: any = new Date();
          let conversion = this.global.getDateTimeString(currentdate);
          let startTime ;
          let endTime ;
          if (
            new Date(conversion).getDate() ==
            new Date(multipleAppointments.startDate).getDate()
          ) {
             startTime =
              multipleAppointments.startTime != null &&
              multipleAppointments.startTime != undefined &&
              multipleAppointments.startTime != ""
                ? new Date(
                    multipleAppointments.startDate +
                      " " +
                      multipleAppointments.startTime
                  )
                : this.global.getDateTimeString(new Date()).toString();
            currentdate = this.datePipe.transform(
              currentdate,
              "yyyy-MM-dd'T'HH:mm"
            );
            startTime = this.datePipe.transform(startTime, "yyyy-MM-dd'T'HH:mm");
         
            if (new Date(startTime).getTime() < new Date(currentdate).getTime()) {
              this.IsButtonDisable = false;
              this.showErr = "Past Timings are not allowed";
              this.toasterService.error("Past Timings are not allowed");
              return;
            }
          }
          if (
            new Date(conversion).getDate() ==
            new Date(multipleAppointments.endDate).getDate()
          ) {
           
             endTime =
              multipleAppointments.endTime != null &&
              multipleAppointments.endTime != undefined &&
              multipleAppointments.endTime != ""
                ? new Date(
                    multipleAppointments.endDate +
                      " " +
                      multipleAppointments.endTime
                  )
                : this.global.getDateTimeString(new Date()).toString();
              
            if (new Date(endTime).getTime() < new Date(currentdate).getTime()) {
              this.IsButtonDisable = false;
              this.showErr = "Past Timings are not allowed";
              this.toasterService.error("Past Timings are not allowed");
              return;
            }
          }
          var PastDates:any=this.datePipe.transform(new Date(currentdate),"MM/dd/yyyy")
          if (new Date(PastDates).getTime() >new Date(multipleAppointments.startDate).getTime() || new Date(PastDates).getTime() >new Date(multipleAppointments.endDate).getTime() ) {
            this.showErr = "Past dates are not allowed";
            this.IsButtonDisable = false;
            this.toasterService.error("Past dates are not allowed");
            return;
          }
          setTimeout(() => {
            this.showErr = "";
          }, 2000);
        }
      });
      if (this.showErr == "") {
        this.promiseCallFunction();
      }
    }
    // ................................................promiseCallFunction...................................................
    promiseCallFunction() {
      this.SaveSchedule()
        .then((data) => {this.IsButtonDisable = false;})
        .catch((err) => {this.IsButtonDisable = false;});
    }
    // ................................................SaveSchedule...................................................
    SaveSchedule() {
      let saveAppointment = JSON.parse(JSON.stringify(this.AppointmentArrayList));
      saveAppointment.forEach((scheduleAppointment) => {
        {
          let startTime =
            scheduleAppointment.startTime != null &&
            scheduleAppointment.startTime != undefined &&
            scheduleAppointment.startTime != ""
              ? new Date(
                  scheduleAppointment.startDate +
                    " " +
                    scheduleAppointment.startTime
                )
              : this.global.getDateTimeString(new Date()).toString();
          let endTime =
            scheduleAppointment.endTime != null &&
            scheduleAppointment.endTime != undefined &&
            scheduleAppointment.endTime != ""
              ? new Date(
                  scheduleAppointment.endDate + " " + scheduleAppointment.endTime
                )
              : this.global.getDateTimeString(new Date()).toString();
          scheduleAppointment.startTime = this.datePipe.transform(
            startTime,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
          scheduleAppointment.endTime = this.datePipe.transform(
            endTime,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
          scheduleAppointment.startDate =
            scheduleAppointment.startDate != null
              ? this.global.getDateTimeString(scheduleAppointment.startDate)
              : null;
          scheduleAppointment.endDate =
            scheduleAppointment.endDate != null
              ? this.global.getDateTimeString(scheduleAppointment.endDate)
              : null;
          scheduleAppointment.employeeId = scheduleAppointment.employeeId
          scheduleAppointment.clientId = this.EditClientId;
          scheduleAppointment.customFrequencyLid =
            scheduleAppointment.customFrequencyLid != null
              ? scheduleAppointment.customFrequencyLid
              : "00000000-0000-0000-0000-000000000000";
          scheduleAppointment.serviceGroupId =
            scheduleAppointment.startDate != null
              ? scheduleAppointment.serviceGroupId
              : "00000000-0000-0000-0000-000000000000";
  
          var customFrequencyValue =
            this.EditScheduleInputProperty.CustomFrequencyList?.filter(
              (fg) => fg.id == scheduleAppointment.customFrequencyLid
            )[0]?.lovName;
          if (customFrequencyValue != undefined && customFrequencyValue != null) {
            if (
              customFrequencyValue == "weekly".toLocaleUpperCase() ||
              customFrequencyValue == "Alternate weeks".toLocaleUpperCase()
            ) {
              scheduleAppointment.FrequencyDays?.forEach(
                (multipleAppointments) => {
                  if (multipleAppointments.ischecked == true) {
                    scheduleAppointment.appointmentDays.push(
                      multipleAppointments.value
                    );
                  }
                }
              );
            } else {
              scheduleAppointment.appointmentDays = [];
              scheduleAppointment.FrequencyDays = [];
            }
          }
        }
      });
      return new Promise((resolve, reject) => {
        this.EditService.SaveSchedule(saveAppointment)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data: any) => {
              this.IsButtonDisable = false;
              resolve(data);
  
              if (data?.length > 0) {
                this.toasterService.error(data);
                return;
              }
              this.toasterService.success("Schedule(s) created successfully");
              setTimeout(() => {
                this.toasterService.clear();
              }, 8000);
              this.CloseSchedule();
            },
            (err: any) => {
              this.IsButtonDisable = false;
              reject(err);
              this.toasterService.error(err, "Error"), 8000;
            }
          );
      });
    }
    // ................................................dataEmitfromChildAuth...................................................
    dataEmitfromChildAuth(event: EditDetailsAuthorization) {
      this.EditAuthorization = false;
      this.AuthorizationInputDetails.isEdit = false;
      this.AuthorizationInputDetails.isView = true;
      this.AuthorizationInputDetails = event;
      this.getAuthDetails();
    }
    // ...........................................showorHideColumns.............................................................
    showorHideColumns() {
      this.gridAuthDetails.columnChooserModule.openColumnChooser(200, 50);
    }
    // ................................................CloseSchedule...................................................
    CloseSchedule() {
      this.EditOutputSchedule.emit({
        isCreate: false,
        isClose: false,
        ClientDropdown: this.EditScheduleInputProperty.ClientDropdown,
        CustomFrequencyList: this.EditScheduleInputProperty.CustomFrequencyList,
      });
    }
    // ................................................Schedulenewdates...................................................
    Schedulenewdates(event, type, name, AppointmentIndex) {
      if (type == "inputchanged") {
        if (name == "EditStart") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.AppointmentArrayList[AppointmentIndex].startDate = val1;
          }
        }
        if (name == "EditEnd") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.AppointmentArrayList[AppointmentIndex].endDate = val1;
          }
        }
      }
      if (type == "datechanged") {
        if (name == "EditStart") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.AppointmentArrayList[AppointmentIndex].startDate = val;
          }
        }
        if (name == "EditEnd") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.AppointmentArrayList[AppointmentIndex].endDate = val;
          }
        }
      }
    }
    // ................................................refreshToGetDropDownValues...................................................
    refreshToGetDropDownValues(code: string) {
      let params = new URLSearchParams();
      params.append("listCode", code);
      this.commonservice.getStatus(params).subscribe((data: any) => {
        if (code == "CUSTOMFREQUENCY") {
          this.EditScheduleInputProperty.CustomFrequencyList = data;
        }
      });
    }
    // ................................................checkCustomFrequencyType...................................................
    checkCustomFrequencyType(customFrequencyLid, index) {
      this.AppointmentArrayList[index].showDays = false;
      this.AppointmentArrayList[index].appointmentDays = [];
  
      var customFrequencyValue =
        this.EditScheduleInputProperty.CustomFrequencyList?.filter(
          (fg) => fg.id == customFrequencyLid
        )[0]?.lovName;
      if (customFrequencyValue != undefined && customFrequencyValue != null) {
        if (
          customFrequencyValue == "weekly".toLocaleUpperCase() ||
          customFrequencyValue == "Alternate weeks".toLocaleUpperCase()
        ) {
          this.AppointmentArrayList[index].showDays = true;
        } else {
          this.AppointmentArrayList[index].showDays = false;
        }
      }
    }
    // ................................................getFrequencyDays...................................................
    getFrequencyDays() {
      let value = [
        {
          Key: "MON",
          value: "MONDAY",
          ischecked: true,
        },
        {
          Key: "TUE",
          value: "TUESDAY",
          ischecked: true,
        },
        {
          Key: "WED",
          value: "WEDNESDAY",
          ischecked: true,
        },
        {
          Key: "THU",
          value: "THURSDAY",
          ischecked: true,
        },
        {
          Key: "FRI",
          value: "FRIDAY",
          ischecked: true,
        },
        {
          Key: "SAT",
          value: "SATURDAY",
          ischecked: true,
        },
        {
          Key: "SUN",
          value: "SUNDAY",
          ischecked: true,
        },
      ];
      return value;
    }
    // ................................................getClientServiceDropdown...................................................
    getClientServiceDropdown(Appointment) {
      if (
        this.EditClientId != null &&
        this.EditClientId != undefined &&
        this.EditClientId != 0 &&
        Appointment.employeeId != null &&
        Appointment.employeeId != 0 &&
        Appointment.employeeId != undefined
      ) {
        let myparams = new URLSearchParams();
        myparams.append("clientId", this.EditClientId.toString());
        myparams.append("employeeId", Appointment.employeeId.toString());
        this.ClientService.getClientServiceDropdown(myparams)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((data) => {
            Appointment.serviceGroup = data;
          });
      } else {
        Appointment.serviceGroup = [];
        Appointment.serviceGroupId = null;
      }
    }
    // ................................................getAuthDetails...................................................
    getActiveClientRelationshipEmployeeList() {
      if (
        this.EditClientId != null &&
        this.EditClientId != undefined &&
        this.EditClientId != ""
      ) {
        let params = new URLSearchParams();
        params.append("clientid", this.EditClientId.toString());
        this.EditService.getActiveClientRelationshipEmployeeList(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((data: any) => {
            this.EmployeeDropdown = data;
          });
      } else {
        this.EmployeeDropdown = [];
      }
    }
    // ................................................getAuthDetails...................................................
    getClientWeekStartAndWeekEnd() {
      if (
        this.EditClientId != null &&
        this.EditClientId != undefined &&
        this.EditClientId != ""
      ) {
        let params = new URLSearchParams();
        params.append("ClientId", this.EditClientId.toString());
        this.EditService.getClientWeekStartAndWeekEnd(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((data: any) => {
            this.clientDetails = data;
          });
      } else {
      }
    }

    getServiceList(serviceGroupId) {
      if(serviceGroupId){
        let params = new URLSearchParams();
        params.append("ServiceGroupId", serviceGroupId);
        params.append("ClientId", this.EditClientId.toString())
        this.EditService.GetServiceDropdown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.serviceList = data;
        })
      }
    }

    public ngOnDestroy(): void {
      this.onDestroy$.next();
    }
  }
  
  